import React, { useEffect } from 'react';
import { LandingPage } from './components/LandingPage';
import { initMetaPixel } from './utils/metaPixel';
export function App() {
  useEffect(() => {
    initMetaPixel();
  }, []);
  return <LandingPage data-id="element-0" />;
}